<template>
    <router-link :to="link" class="preview">
        <h2 v-text="title"></h2>
        <span class="date" v-text="publishedDate"></span>
        <img :src="imgUrl" alt="">
        <div class="excerpt" v-html="excerpt"></div>
    </router-link>
</template>

<script>
    import moment from 'moment'

    export default {
        name: "PostPreview",
        props: {
            post: { required: true },
        },
        computed: {
            publishedDate() {
                if( this.post == null ) {
                    return null
                }
                let d = moment(this.post.date)
                return d.format("DD MMM YYYY")
            },
            postObj() {
                return this.$store.getters['posts/id'](this.post.id)
            },
            excerpt() {
                if( this.postObj == null ) {
                    return ""
                }
                return this.postObj.excerpt.rendered
            },
            imgUrl() {
                if( this.postObj == null ) {
                    return ""
                }
                return this.postObj.images.medium
            },
            link() {
                if( this.postObj == null ) {
                    return ""
                }
                return {
                    name: 'post',
                    params: {slug: this.postObj.slug},
                }
            },
            title() {
                return this.post.title
            },
        },
        watch: {
            postObj: {
                immediate: true,
                handler() {
                    if( this.postObj != null ) {
                        return
                    }
                    this.$store.dispatch('posts/getId', this.post.id)
                },
            },
        },
    }
</script>

<style scoped lang="scss">
.preview {
    display: grid;
    grid-template-columns: 1fr min-content;
    grid-template-rows: min-content min-content 1fr;
    gap: 0 1rem;
    grid-template-areas: 
        "title img"
        "date img"
        "excerpt img"
        ;

    h2 {
        grid-area: title;
        margin: 0;
    }

    img {
        grid-area: img;
        height: 12rem;
        width: auto;
    }

    span {
        grid-area: date;
        margin-bottom: .5em;
        font-size: .9rem;
    }

    .excerpt {
        grid-area: excerpt;
    }
}
</style>
